(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mini-banners')) {
    customElements.define('mini-banners', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.js-mb-track');
        this.prev = this.querySelector('.js-mb-prev');
        this.next = this.querySelector('.js-mb-next');
        if (!this.track || !this.classList.contains('mini-banners--carousel')) return;
        this.actualizar = () => {
          if (!this.prev || !this.next) return;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max;
        };
        this.alScroll = () => this.actualizar();
        this.track.addEventListener('scroll', this.alScroll, { passive: true });
        window.addEventListener('resize', this.actualizar);
        window.addEventListener('load', this.actualizar);
        if (this.prev) this.prev.addEventListener('click', () => this.mover(-1));
        if (this.next) this.next.addEventListener('click', () => this.mover(1));
        this.actualizar();
        const ms = parseInt(this.dataset.autoplay || '0', 10);
        if (ms > 0) {
          this.pausa = false;
          this.addEventListener('mouseenter', () => { this.pausa = true; });
          this.addEventListener('mouseleave', () => { this.pausa = false; });
          this.timer = window.setInterval(() => { if (!this.pausa) this.mover(1, true); }, ms);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.actualizar);
        window.removeEventListener('load', this.actualizar);
        if (this.timer) window.clearInterval(this.timer);
      }
      mover(dir, volver) {
        const item = this.track.querySelector('.mini-banners__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const paso = item.getBoundingClientRect().width + gap;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (volver && dir > 0 && this.track.scrollLeft >= max) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.track.scrollBy({ left: dir * paso, behavior: 'smooth' });
        }
        window.setTimeout(this.actualizar, 80);
        window.setTimeout(this.actualizar, 700);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
